var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFobizzLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.91 5.54 181.63 212.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17bbb9",
    d: "M12.61,53s-5.44,0-5.44,5.43v60.13s0,5.43,5.44,5.43h89.07s5.43,0,5.43-5.43V58.44s0-5.43-5.43-5.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b22687",
    d: "M40,106.14s-5.43,0-5.43,5.43V166.1s0,5.44,5.43,5.44H137.8s5.43,0,5.43-5.44V111.57s0-5.43-5.43-5.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#faa627",
    d: "M6.91,213s0,5.43,5.43,5.43H47.09s5.44,0,5.44-5.43V158.51s0-5.43-5.44-5.43H12.34s-5.43,0-5.43,5.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2c93e",
    d: "M67.06,5.54s-5.44,0-5.44,5.44v71.8s0,5.43,5.44,5.43H183.11s5.43,0,5.43-5.43V11s0-5.44-5.43-5.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#95272b",
    d: "M52.53,171.53v-13s0-5.43-5.44-5.43H34.6v13s0,5.43,5.43,5.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#612363",
    d: "M107.11,118.57V106.14H40s-5.43,0-5.43,5.43V124h67.08s5.43,0,5.43-5.43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#349e49",
    d: "M107.11,88.21V58.44s0-5.43-5.43-5.43H61.62V82.78s0,5.43,5.44,5.43Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFobizzLogo);
export default __webpack_public_path__ + "static/media/fobizz-logo.5d76f6786e7a7f86ec54e001a79fc087.svg";
export { ForwardRef as ReactComponent };